// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dividend-container {
  container-type: inline-size;
  font-family: 'Arial', 'Helvetica', 'Sans-serif';
  width: 100%;
  box-sizing: border-box;
}

.dividend-container .dh-ratios-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  width: 100%;
  padding: 0 32px;
  box-sizing: border-box;
}

.dividend-container .dh-ratio-card {
  background-color: var(--surface-tertiary);
  border-radius: 2px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex: 1 1 calc(50% - 4px);
  min-width: 0;
  min-height: 72px;
  box-sizing: border-box;
}

@container (min-width: 768px) {
  .dividend-container .dh-ratio-card {
    flex-basis: calc(25% - 6px);
  }
}

@container (max-width: 480px) {
  .dividend-container .dh-ratios-grid {
    padding: 0 16px;
  }
}

@container (max-width: 360px) {
  .dividend-container .dh-ratio-card {
    flex-basis: 100%;
  }
}

.dividend-container .dh-ratio-label {
  font-size: 14px;
  font-weight: 400;
  text-align: left;
  color: var(--text-label);
}

.dividend-container .dh-ratio-value-row {
  display: flex;
  align-items: baseline;
  color: var(--text-primary);
  margin-top: 4px;
  gap: 2px;
}

.dividend-container .dh-ratio-value {
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
}

.dividend-container .dh-ratio-suffix {
  font-size: 14px;
  font-weight: 400;
  text-transform: uppercase;
}

.dividend-container .dh-history-section {
  margin-top: 24px;
  width: 100%;
}

.dividend-container .dh-table-scroll {
  width: 100%;
  overflow-x: auto;
}

.dividend-container .dh-table {
  width: 100%;
  min-width: 1024px;
  border-collapse: collapse;
  border-spacing: 0;
}

.dividend-container .dh-table thead th {
  text-align: left;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-subheader);
  padding: 0 16px 8px 0;
  box-shadow: inset 0 -1px 0 0 var(--border-line);
  white-space: nowrap;
  box-sizing: border-box;
}
.dividend-container .dh-table thead th:first-child,
.dividend-container .dh-table thead th:last-child {
  width: 32px;
  border: none;
}

.dividend-container .dh-table tbody td:first-child,
.dividend-container .dh-table tbody td:last-child {
  width: 32px;
}
.dividend-container .dh-table tbody td {
  text-align: left;
  font-size: 16px;
  height: 24px;
  font-weight: 400;
  color: var(--text-primary);
  padding: 8px 16px 8px 0;
  white-space: nowrap;
  box-sizing: content-box;
}

.dividend-container .dh-table tbody tr:nth-child(2n) {
  background-color: var(--row-dark);
}

.dividend-container .dh-table .dh-col-date,
.dividend-container .dh-table .dh-col-type {
  min-width: 120px;
}
.dividend-container .dh-table .dh-col-amount {
  min-width: 140px;
}
.dividend-container .dh-table .dh-col-franked,
.dividend-container .dh-table .dh-col-drp {
  min-width: 108px;
}

.dividend-container .dh-table-unit {
  font-size: 12px;
  text-transform: uppercase;
}

.dividend-container .dh-pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 12px;
}
`, "",{"version":3,"sources":["webpack://./src/Widgets/DividendHistoryWidget/DividendHistoryWidget.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,+CAA+C;EAC/C,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4BAA4B;EAC5B,qBAAqB;EACrB,+CAA+C;EAC/C,mBAAmB;EACnB,sBAAsB;AACxB;AACA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB","sourcesContent":[".dividend-container {\n  container-type: inline-size;\n  font-family: 'Arial', 'Helvetica', 'Sans-serif';\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.dividend-container .dh-ratios-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  width: 100%;\n  padding: 0 32px;\n  box-sizing: border-box;\n}\n\n.dividend-container .dh-ratio-card {\n  background-color: var(--surface-tertiary);\n  border-radius: 2px;\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  flex: 1 1 calc(50% - 4px);\n  min-width: 0;\n  min-height: 72px;\n  box-sizing: border-box;\n}\n\n@container (min-width: 768px) {\n  .dividend-container .dh-ratio-card {\n    flex-basis: calc(25% - 6px);\n  }\n}\n\n@container (max-width: 480px) {\n  .dividend-container .dh-ratios-grid {\n    padding: 0 16px;\n  }\n}\n\n@container (max-width: 360px) {\n  .dividend-container .dh-ratio-card {\n    flex-basis: 100%;\n  }\n}\n\n.dividend-container .dh-ratio-label {\n  font-size: 14px;\n  font-weight: 400;\n  text-align: left;\n  color: var(--text-label);\n}\n\n.dividend-container .dh-ratio-value-row {\n  display: flex;\n  align-items: baseline;\n  color: var(--text-primary);\n  margin-top: 4px;\n  gap: 2px;\n}\n\n.dividend-container .dh-ratio-value {\n  font-size: 20px;\n  font-weight: 700;\n  line-height: 28px;\n}\n\n.dividend-container .dh-ratio-suffix {\n  font-size: 14px;\n  font-weight: 400;\n  text-transform: uppercase;\n}\n\n.dividend-container .dh-history-section {\n  margin-top: 24px;\n  width: 100%;\n}\n\n.dividend-container .dh-table-scroll {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.dividend-container .dh-table {\n  width: 100%;\n  min-width: 1024px;\n  border-collapse: collapse;\n  border-spacing: 0;\n}\n\n.dividend-container .dh-table thead th {\n  text-align: left;\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 24px;\n  color: var(--text-subheader);\n  padding: 0 16px 8px 0;\n  box-shadow: inset 0 -1px 0 0 var(--border-line);\n  white-space: nowrap;\n  box-sizing: border-box;\n}\n.dividend-container .dh-table thead th:first-child,\n.dividend-container .dh-table thead th:last-child {\n  width: 32px;\n  border: none;\n}\n\n.dividend-container .dh-table tbody td:first-child,\n.dividend-container .dh-table tbody td:last-child {\n  width: 32px;\n}\n.dividend-container .dh-table tbody td {\n  text-align: left;\n  font-size: 16px;\n  height: 24px;\n  font-weight: 400;\n  color: var(--text-primary);\n  padding: 8px 16px 8px 0;\n  white-space: nowrap;\n  box-sizing: content-box;\n}\n\n.dividend-container .dh-table tbody tr:nth-child(2n) {\n  background-color: var(--row-dark);\n}\n\n.dividend-container .dh-table .dh-col-date,\n.dividend-container .dh-table .dh-col-type {\n  min-width: 120px;\n}\n.dividend-container .dh-table .dh-col-amount {\n  min-width: 140px;\n}\n.dividend-container .dh-table .dh-col-franked,\n.dividend-container .dh-table .dh-col-drp {\n  min-width: 108px;\n}\n\n.dividend-container .dh-table-unit {\n  font-size: 12px;\n  text-transform: uppercase;\n}\n\n.dividend-container .dh-pagination-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 12px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
